// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1LG6J","itemTitle":"ClientEmergencyInfo_itemTitle__1d4gz","itemText":"ClientEmergencyInfo_itemText__1IVDF"};